import { ViewportType } from '../../../enums/index.js';
import { getVideoProjectionPresentation, withVideoProjectionPresentation, } from './videoProjectionPresentation.js';
import { getVideoProjectionSnapshot } from './videoProjectionSnapshot.js';
import { VIDEO_PROJECTION_ID, } from './VideoProjectionTypes.js';
export { getVideoProjectionSnapshot };
export const videoProjectionAdapter = {
    id: VIDEO_PROJECTION_ID,
    viewportTypes: [ViewportType.VIDEO_NEXT],
    getSnapshot: (request) => getVideoProjectionSnapshot(request),
    getPresentation: (snapshot, selector) => getVideoProjectionPresentation(snapshot, selector),
    withPresentation: (snapshot, presentation, options) => withVideoProjectionPresentation(snapshot, presentation, options),
};
